import * as React from "react";

export interface LoaderProps {
  loading?: boolean;
  color?: string;
  size?: number;
  sizeUnit?: string;
  margin?: string;
  className?: string;
  style?: React.CSSProperties;
}

const defaultProps: Partial<LoaderProps> = {
  loading: true,
  color: "var(--color-text-primary)",
  size: 15,
  sizeUnit: "px",
  margin: "2px",
};

const styleGenerator = (i, props: LoaderProps): React.CSSProperties => {
  const { color, size, sizeUnit, margin } = { ...defaultProps, ...props };
  return {
    display: "inline-block",
    backgroundColor: color,
    width: `${size}${sizeUnit}`,
    height: `${size}${sizeUnit}`,
    margin,
    borderRadius: "100%",
    animation: `loader 0.7s ${i % 2 ? "0s" : "0.35s"} infinite linear`,
    animationFillMode: "both",
  };
};

const Loader: React.FunctionComponent<LoaderProps> = React.memo((props) => {
  // if (props.loading) return <></>;

  return (
    <div style={{ display: "inline-block" }}>
      <div style={styleGenerator(1, props)} />
      <div style={styleGenerator(2, props)} />
      <div style={styleGenerator(3, props)} />
    </div>
  );
});

export const CenteredLoader: React.FunctionComponent<LoaderProps> = React.memo((props) => (
  <div
    style={{
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: "fit-content",
      ...(props.style || {}),
    }}
  >
    <Loader {...props} />
  </div>
))

export default Loader;
